import { Controller } from '@hotwired/stimulus'
import { fetchJson } from 'util/fetch'
import { csrfParams } from 'util/params'

// Connects to data-controller="alert-banner"
export default class extends Controller {
  static values = {
    dismissUrl: String
  }

  dismiss () {
    if (this.dismissUrlValue) {
      fetchJson(this.dismissUrlValue, 'DELETE', csrfParams())
    }

    // Fade out animation
    this.element.style.transition = 'opacity 200ms ease-out'
    this.element.style.opacity = '0'

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 200)
  }
}
